// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Atom_Cta from "../design-system/atom/Atom_Cta.bs.js";
import * as Atom_Text from "../design-system/atom/Atom_Text.bs.js";
import * as Atom_Select from "../design-system/atom/Atom_Select.bs.js";
import * as GlobalStyle from "../design-system/GlobalStyle.bs.js";
import * as Presse_Menu from "./Presse/Presse_Menu.bs.js";
import * as Atom_Checkbox from "../design-system/atom/Atom_Checkbox.bs.js";
import * as Presse_Footer from "./Presse/Presse_Footer.bs.js";
import * as Presse_Header from "./Presse/Presse_Header.bs.js";
import * as Provider_I18n from "../provider/Provider_I18n.bs.js";
import * as Atom_Textfield from "../design-system/atom/Atom_Textfield.bs.js";
import * as Page_Rc_Presse from "../design-system/page/Page_Rc_Presse.bs.js";
import * as Provider_Config from "../provider/Provider_Config.bs.js";
import * as Page_Guide_Presse from "../design-system/page/Page_Guide_Presse.bs.js";
import * as Presse_Input_Label from "./Presse/Presse_Input_Label.bs.js";
import * as Page_Program_Presse from "../design-system/page/Page_Program_Presse.bs.js";
import * as Organism_Carousel_Presse from "../design-system/organism/carousel/Organism_Carousel_Presse.bs.js";
import * as Molecule_TopTeaser_Presse from "../design-system/molecule/Molecule_TopTeaser_Presse.bs.js";

Provider_I18n.make.displayName = "I18nProvider";

Provider_Config.make.displayName = "ConfigProvider";

function globalStyle(withFont) {
  GlobalStyle.make(withFont, "Light", false, undefined);
}

Organism_Carousel_Presse.make.displayName = "Carousel";

Presse_Menu.make.displayName = "Menu";

Molecule_TopTeaser_Presse.make.displayName = "TopTeaser";

Page_Program_Presse.make.displayName = "ProgramPage";

Page_Rc_Presse.make.displayName = "RcPage";

Page_Guide_Presse.make.displayName = "AgendaPage";

Presse_Header.make.displayName = "Header";

Presse_Footer.make.displayName = "Footer";

var Typography = Atom_Text.Presse.make;

Typography.displayName = "Typography";

var Textfield = Atom_Textfield.Presse.make;

Textfield.displayName = "Textfield";

var Button = Atom_Cta.Presse.Button.make;

Button.displayName = "Button";

var Dropdown = Atom_Select.Presse.make;

Dropdown.displayName = "Dropdown";

Presse_Input_Label.make.displayName = "InputLabel";

var Checkbox = Atom_Checkbox.Presse.make;

Checkbox.displayName = "Checkbox";

var I18nProvider = Provider_I18n.make;

var ConfigProvider = Provider_Config.make;

var Carousel = Organism_Carousel_Presse.make;

var Menu = Presse_Menu.make;

var TopTeaser = Molecule_TopTeaser_Presse.make;

var ProgramPage = Page_Program_Presse.make;

var RcPage = Page_Rc_Presse.make;

var AgendaPage = Page_Guide_Presse.make;

var Header = Presse_Header.make;

var Footer = Presse_Footer.make;

var InputLabel = Presse_Input_Label.make;

export {
  I18nProvider ,
  ConfigProvider ,
  globalStyle ,
  Carousel ,
  Menu ,
  TopTeaser ,
  ProgramPage ,
  RcPage ,
  AgendaPage ,
  Header ,
  Footer ,
  Typography ,
  Textfield ,
  Button ,
  Dropdown ,
  InputLabel ,
  Checkbox ,
}
/*  Not a pure module */
